"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TrError extends Error {
    static isTrError(error) {
        return error.code && typeof error.getCode === 'function' && typeof error.export === 'function';
    }
    constructor(message, code, localizedError = '') {
        super(message);
        // see https://medium.com/@xjamundx/custom-javascript-errors-in-es6-aa891b173f87
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TrError);
        }
        this.code = code;
        this.localizedMessage = localizedError;
    }
    getCode() {
        return this.code;
    }
    export() {
        return {
            localizedMessage: this.localizedMessage,
            error: this.message,
            errorCode: this.code
        };
    }
    toString() {
        return this.message + ' (' + this.code + ')';
    }
}
exports.default = TrError;
//# sourceMappingURL=TrError.js.map